import { computed, reactive } from "vue";

export type FilterOptions = Record<string, boolean>;

export type FilterObject<T> = {
  id: string;
  title: string;
  matches: (types: string[]) => (item: T) => boolean;
  options: FilterOptions;
  checked: string[];
  show: boolean;
};

export function createFilterObject<T>(
  id: string,
  title: string,
  filterCallback: (types: string[]) => (item: T) => boolean,
  itemsForOptions: T[],
  optionProp: (item: T) => string | undefined | (string | undefined)[],
): FilterObject<T> {
  const options: FilterOptions = {};
  itemsForOptions
    .flatMap(optionProp)
    .filter((option) => option !== undefined)
    .sort((a, b) => (a.toLowerCase() > b.toLowerCase() ? 1 : -1))
    .forEach((option) => {
      options[option] = false;
    });

  const checked = computed(() =>
    Object.keys(filterObject.options).filter(
      (key) => filterObject.options[key],
    ),
  );
  const filterObject: FilterObject<T> = reactive({
    id,
    title,
    matches: filterCallback,
    options,
    checked: checked,
    show: computed(() => Object.keys(filterObject.options).length > 1),
  });

  return filterObject;
}
